// extracted by mini-css-extract-plugin
export default {"textbox":"kzwICWX0TB4Dp138tHeP","disabled":"mz7iPXXgRzYLTP7GNLbf","textareaBlocked":"sd56TtVx1Kh8OtcipxBx","textarea":"bGXAwaLAbRuItzq5229X","emojiBlocked":"aSlRVJ5Jewyw8Cs7roHm"};